import { createAsyncThunk } from '@reduxjs/toolkit'
import { PaymentObligationState } from '@types'
import {
  STORE_OBLIGATION,
  STORE_OBLIGATION_FETCH,
  STORE_STATUS_INITIALIZED,
} from 'constants/store'
import {
  createGenericSlice,
  createReducers,
  ExtraReducers,
  GenericState,
} from 'stores/generics'
import { Payload } from 'stores'

export type State = GenericState<PaymentObligationState | null>

export const initialState: State = {
  data: null,
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchObligations = createAsyncThunk<
  PaymentObligationState | null,
  any,
  Payload
>(STORE_OBLIGATION_FETCH, async (promise, { rejectWithValue }) => {
  try {
    return await promise
  } catch (e: any) {
    const { code, message } = e
    return rejectWithValue({ code, message })
  }
})

const extraReducers: ExtraReducers = createReducers<
  PaymentObligationState | null,
  PaymentObligationState | null,
  Payload
>(fetchObligations, initialState.data)

const obligationSlice = createGenericSlice({
  name: STORE_OBLIGATION,
  initialState,
  reducers: {
    addObligation(state, action) {
      state.data = action.payload
    },
  },
  extraReducers,
})

const { actions, reducer } = obligationSlice

const { addObligation } = actions

export { addObligation }

export default reducer
